import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const CategoryLegacy = lazy(
  () =>
    import('./CategoryLegacy.eager').then(mod => ({
      default: mod.CategoryLegacy,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
